import * as React from "react";
import { cn } from "@/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // Base styles
          "flex min-h-[80px] w-full rounded-xl px-3 py-2 text-sm ring-offset-background transition-colors",
          // Background & Border
          "bg-secondary border border-transparent",
          // Placeholder
          "placeholder:text-muted-foreground",
          // Focus state (Sangat penting untuk Dark Mode)
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          // Disabled state
          "disabled:cursor-not-allowed disabled:opacity-50",
          // Dark Mode specific tweaks (Jika variabel CSS tidak cukup kontras)
          "dark:bg-slate-900/50 dark:border-slate-800 dark:text-slate-100 dark:focus-visible:ring-blue-500/50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
